import {MenuDetails} from "../../../rest/jtmc/models/MenuDetails";
import {FlatList, Pressable, SafeAreaView, View} from "react-native";
import React, {useContext, useEffect, useRef, useState} from "react";
import { Image} from "react-native";
import Category from "../../../rest/jtmc/models/Category";
import {Product} from "../../../rest/jtmc/models/Product";
import ProductItem from "../components/ProductItem";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {useFocusEffect} from "@react-navigation/native";
import {OrderContext} from "../../../contexts/OrderContext";
import NoProductItem from "../components/NoProductItem";
import {MenuActionButtonStyles} from "../styles";
import {
    CartPageActionButton,
    GamesPageActionButton,
    ProfilePageActionButton,
    WaiterCallButton
} from "../components/MenuActionsComponents";
import MenuScreenFunction from "../../../components/screen-functions-components/MenuScreenFunction";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";
import { color } from "react-native-reanimated";
import { ProductAndItsCategory } from "../../../rest/jtmc/models/ProductAndItsCategory";
import Text from "../components/Text";
import FontAwesome from "../components/FontAwesome";
import CategoryEndGrad from "../assets/CategoryEndGrad";
import NewHeader from "../components/NewHeader";

export default function Menu({navigation}: any) {
    const configContext = useContext(AppConfigContext);
    const appFunctions = useContext(AppFunctionsContext);
    const [menuDetails, setMenuDetails] = useState<MenuDetails>();

    useFocusEffect(React.useCallback(() => {
        configContext.setPageTitle("");
        configContext.setIfPageHasHeader(false);
    }, []));

    const [selectedCategoryId, setSelectedCategoryId] = useState(0);

    useEffect(()=>{
        if(menuDetails != null)
            setSelectedCategoryId(menuDetails.menuItems[0].category.id)
    }, [menuDetails])

    return <MenuScreenFunction onMenuDetailsChange={m => setMenuDetails(m)}>
        <NewHeader menuDetails={menuDetails}/>
        <HeaderCategory menuDetails={menuDetails} selectedId={selectedCategoryId} onChange={(id: number)=>{
            setSelectedCategoryId(id);
        }}/>
        <ProductList
            menuDetails={menuDetails} selectedCategoryId={selectedCategoryId}/>
        <MenuActionsView
            menuDetails={menuDetails}/>
    </MenuScreenFunction>
}



//function HeaderNotCategory(props: {menuDetails: MenuDetails | undefined}) {
//    const config = useContext(AppConfigContext);
//    const colors = Colors.instanceNoServerColor(config.theme, "#376864");
//    return (
//        <View style={{padding: "8px"}}>
//            <View style={{display: "flex", flexDirection: "row", 
//                    borderRadius:20, shadowOpacity: 0.1, shadowRadius:4,shadowOffset:{height: 3,width: 3},backgroundColor: colors.get("highConHeader") as string}}>
//                <Centered>
//                {props.menuDetails != null ? <Text style={{color:colors.get("primaryColor") as string,fontFamily:"IRANSans_Bold"}}>{props.menuDetails.branchInfo.storeName}</Text> : <></>}
//                </Centered>
//                <View>
//                    {props.menuDetails != null ? <Image style={{
//                                width: 60,
//                                height: 60,
//                                margin: "8px"
//                                
//                            }} source={{uri: props.menuDetails.branchInfo.logoUrl}}/> : <></>}
//                </View>
//                <Centered>
//                <Text style={{color:colors.get("primaryColor") as string,fontFamily:"IRANSans_Bold"}}>آماده پذیرش سفارشات</Text>
//                </Centered>
//            </View>
//        </View>
//    );
//};


function HeaderNotCategory(props: {menuDetails: MenuDetails | undefined}) {
    const config = useContext(AppConfigContext);
    const colors = Colors.instanceNoServerColor(config.theme, "#376864");

    return (
        <View style={{padding: "8px"}}>
            <View style={{display: "flex", flexDirection: "row", backgroundColor: colors.get("highConHeader") as string, borderRadius: 15, shadowOpacity: 0.1, shadowRadius:4, shadowOffset: {height: 2, width: 2}} }>
                <View>
                    {props.menuDetails != null ? <Image style={{
                                width: 60,
                                height: 60,
                                margin: "8px",
                                borderRadius: 13,
                                
                            }} source={{uri: props.menuDetails.branchInfo.logoUrl}}/> : <></>}
                </View>
                
                <View style={{
                    flexGrow: 1,
                    justifyContent: "center",
                    alignItems: "flex-start",
                    paddingBottom: 2
                }}>
                    {props.menuDetails != null ? <Text size={18} style={{color:colors.get("primaryColor") as string}} weight={600}>
                        {props.menuDetails.branchInfo.storeName}
                        </Text> : <></>}
                    <Text size={12} style={{color:colors.get("primaryColor") as string,fontFamily:"IRANSans_Medium"}}>آماده پذیرش سفارشات</Text>
                </View>
                
                <View style={{
                    padding: 8,
                    flexDirection: "row",
                    gap: 10,
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft:10
                }}>
                    <View style={{borderColor:colors.get("primaryColor") as string, borderWidth:1, borderRadius: 10,padding:6.9}}><FontAwesome icon={''} color={colors.get("primaryColor") as string} type={"solid"} size={20}/></View>
                    <View style={{borderColor:colors.get("primaryColor") as string, borderWidth:1, borderRadius: 10,padding:6.9}}><FontAwesome icon={''} color={colors.get("primaryColor") as string} type={"solid"} size={20}/></View>
                </View>

            </View>
        </View>
    );
};

function HeaderCategory(props: {menuDetails: MenuDetails | undefined, onChange: (id: number)=>void, selectedId: number}) {
    const config = useContext(AppConfigContext);
    const colors = Colors.instanceNoServerColor(config.theme, "#376864");
    
    const selectedStyle = {
        backgroundColor: colors.get("primaryColor") as string,
        borderRadius:15,
        borderColor:colors.get("highConHeader") as string,
        borderWidth:0, 
        padding:5,
        marginLeft:8,
        marginBottom:6,
        paddingHorizontal:15,
        shadowColor: colors.get("primaryColor"),
        shadowOpacity: 0.4,
        shadowRadius: 6.9,
        shadowOffset: {height: 2, width: 2},
    }


    const unselectedStyle = {
        backgroundColor: colors.get("highConHeader") as string,
        borderRadius:15,
        borderColor:colors.get("primaryColor") as string,
        borderWidth:1, 
        padding:5,
        marginLeft:8,
        marginBottom: 6 ,
        paddingHorizontal:15,
        shadowOpacity: 0.1,
        shadowRadius: 4,
        shadowOffset: {height: 2, width: 2},
    }
    
    const selectedTextStyle = {
        color:colors.get("highConHeader") as string,
        fontSize: 16,
        fontFamily:"IRANSans",
    }

    const unSelectedTextStyle = {
        color:colors.get("primaryColor") as string,
        fontSize: 16, 
        fontFamily:"IRANSans"
    }

    return (
        <View style={{
            position: "relative"
        }}>
        
            <View style={{marginTop:0,overflow:"visible"}}>
                    <FlatList horizontal renderItem={(item)=>
                        <Pressable onPress={()=>{props.onChange(item.item.category.id)}} style={props.selectedId == item.item.category.id ? selectedStyle : unselectedStyle}>
                            <Text style={props.selectedId == item.item.category.id ? selectedTextStyle : unSelectedTextStyle}>
                                {item.item.category.name}
                            </Text>
                        </Pressable>} 
                    data={props.menuDetails?.menuItems ?? []} showsHorizontalScrollIndicator={false} style={{paddingHorizontal:9}}/>
            </View>
            <View style={{
                position: "absolute",
                left: 0, top: 0, transform: [{
                    scaleX: 2
                }]
            }}>
                <CategoryEndGrad/>
            </View>
        </View>
    );
};

function Centered(props: {children: any}){
    return <View style={{flex: 1, justifyContent: "center", alignItems: 'center', padding: "4px"}}>
        {props.children}
    </View>
}


function ProductList(props: any) {
    const menuDetails: MenuDetails = props.menuDetails;
    if (menuDetails == null)
        return <></>;

    const [productsToShow, setProductsToShow] = useState<Product[]>();
    menuDetails?.menuItems.forEach((item, index) => {
        if ((item.category?.id == props.selectedCategoryId) && (item.products != productsToShow))
            setProductsToShow(item.products);
    });
    const flatList = useRef().current;
    const hasProducts = (productsToShow?.length ?? 0) != 0;

    return hasProducts ?
        <SafeAreaView style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            overflow: "visible",
            top: 0,
            bottom: 0,
            zIndex: -1
        }}>
            <FlatList ref={flatList} showsVerticalScrollIndicator={false} contentContainerStyle={{flexGrow: 1}} style={{
                marginTop: 0,
                maxWidth: "100%",
                paddingTop: 130,
                paddingBottom: 80
            }} data={productsToShow} renderItem={(item) => {
                return <ProductItem orderable={menuDetails.menuOptionsAccess.ordering} product={item.item}/>
            }}/>
        </SafeAreaView> : <View style={{marginTop: -4}}><NoProductItem/></View>
}

function MenuActionsView(props: any) {
    const menuDetails: MenuDetails = props.menuDetails;

    const appConfigContext = useContext(AppConfigContext);
    const color = Colors.instanceNoServerColor(appConfigContext.theme, "#376864");
    const order = useContext(OrderContext);

    const lStyle = MenuActionButtonStyles(color);

    const actionButtonSet = [];

    switch (order.order?.type) {
        case "outside":
            actionButtonSet.push(<ProfilePageActionButton key={0} grow={25}/>);

            if (menuDetails?.menuOptionsAccess.ordering)
                actionButtonSet.push(<CartPageActionButton key={1} grow={50} menuDetails={menuDetails}/>);

            if (menuDetails?.menuOptionsAccess.games)
                actionButtonSet.push(<GamesPageActionButton key={2} grow={25}/>);
            break;
        case "table":
            if (menuDetails?.menuOptionsAccess.games)
                actionButtonSet.push(<GamesPageActionButton key={0} grow={25}/>);

            if (menuDetails?.menuOptionsAccess.ordering)
                actionButtonSet.push(<CartPageActionButton key={1} grow={50} menuDetails={menuDetails}/>);

            if (menuDetails?.menuOptionsAccess.waiter_call)
                actionButtonSet.push(<WaiterCallButton key={2} grow={25}/>);
            break;
        case "takeaway":
            if (menuDetails?.menuOptionsAccess.ordering)
                actionButtonSet.push(<CartPageActionButton key={0} grow={50} menuDetails={menuDetails}/>);

            if (menuDetails?.menuOptionsAccess.games)
                actionButtonSet.push(<GamesPageActionButton key={0} grow={50}/>);
            break;
    }
 
    return <View style={lStyle.buttonContainer}>
        {actionButtonSet}
    </View>
};


